module.exports = __webpack_public_path__ + "img/ico_daijinquan.a8da2143.png";